export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.24.2';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// /var/bffdotfm-theme/prod/shared/~/@sentry/browser/esm/version.js
// module id = 33
// module chunks = 0